import moment from 'moment';
import 'moment-timezone';
import Swal from 'sweetalert2';
import CryptoJS from 'crypto-js';
import { SP_HANDOFF_SECRET } from '../config/constents';

export const base64 = {
    encode(text: string) {
        //return btoa(text);
        return (text);
    },
    decode(text: string) {
        //return atob(text);
        return (text);
    }
}

export const numberFormat = (val: number = 0) => {
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const formatDateTime = (date: any) => {
    let dateReturn = '-';
    try {
        if (date !== '' && date !== null) {
            const _date = moment.tz(date, moment.tz.guess()).toDate();
            dateReturn = moment(_date).format('DD-MMM-YYYY hh:mm:ss A');
        }
    } catch (e) {
        dateReturn = '-';
    }

    return dateReturn;
}

export const formatDate = (date: any) => {
    let dateReturn = '-';
    try {
        if (date !== '' && date !== null) {
            const _date = moment.tz(date, moment.tz.guess()).toDate();
            dateReturn = moment(_date).format('DD-MMM-YYYY');
        }
    } catch (e) {
        dateReturn = '-';
    }

    return dateReturn;
}

export const currencyFormat = (value: number) =>
    new Intl.NumberFormat('en-Us', {
        style: 'currency',
        currency: 'USD'
    }).format(value || 0);

type Order = 'asc' | 'desc';

export const sortTableData = (data: any, order: any, orderBy: any) => {
    return stableSort(data, getComparator(order, orderBy))
}

function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}


function getComparator<Key extends keyof any>(order: Order, orderBy: Key): (
    a: { [key in Key]: number | string },
    b: { [key in Key]: number | string },
) => number {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort<T>(array: readonly T[], comparator: (a: T, b: T) => number) {
    const stabilizedThis = array?.map((el, index) => [el, index] as [T, number]);
    stabilizedThis?.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) {
            return order;
        }
        return a[1] - b[1];
    });
    return stabilizedThis?.map((el) => el[0]);
}


export const encryptData = (data: any) => {
    // Generate a random 256-bit key and 128-bit IV
    const key = CryptoJS.lib.WordArray.random(32); // 256-bit key
    const iv = CryptoJS.lib.WordArray.random(16);  // 128-bit IV

    // Encrypt using AES-CBC with PKCS7 padding
    const encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });

    return {
        data: encrypted.ciphertext.toString(CryptoJS.enc.Base64), // Encrypted text
        key: CryptoJS.enc.Base64.stringify(key), // Key (Base64)
        iv: CryptoJS.enc.Base64.stringify(iv),   // IV (Base64)
    };
};


export const decryptData = (encryptedData: string, key: string, iv: string) => {
    const cipherParams = CryptoJS.lib.CipherParams.create({
        ciphertext: CryptoJS.enc.Base64.parse(encryptedData),
    });

    const decrypted = CryptoJS.AES.decrypt(
        cipherParams,
        CryptoJS.enc.Base64.parse(key),
        {
            iv: CryptoJS.enc.Base64.parse(iv),
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        }
    );

    return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
};

/** Decrypt SP signup → platform handoff token. Returns email or null if invalid/expired. */
export const decryptServiceProviderHandoffToken = (token: string): string | null => {
    try {
        if (!token) return null;
        const decrypted = CryptoJS.AES.decrypt(token, SP_HANDOFF_SECRET).toString(CryptoJS.enc.Utf8);
        if (!decrypted) return null;
        const payload = JSON.parse(decrypted);
        if (!payload?.email || !payload?.exp) return null;
        if (Date.now() > Number(payload.exp)) return null;
        return String(payload.email).trim();
    } catch {
        return null;
    }
};

type SweetAlertIcon = 'success' | 'error' | 'warning' | 'info' | 'question'
let stylesInjected = false;
export const CustomAlert = (alertType: SweetAlertIcon | undefined, message: string) => {
    if (!stylesInjected) {
        const style = document.createElement("style");
        style.innerHTML = `
      .toast-popup {
        font-family: 'Roboto', sans-serif !important;
        font-size: 14px !important;
        border-radius: 8px !important;
        padding: 10px 20px !important;
        font-weight: 300 !important;
        color: black !important;
      }

      .toast-popup.swal2-icon-success {
        background-color: #E6F9F0 !important;
        color: #006644 !important;
        border: 2px solid #00B67A !important;
      }

      .toast-popup.swal2-icon-error {
        background-color: #FDEAEA !important;
        color: #8A1C1C !important;
        border: 2px solid #E53935 !important;
      }

      .toast-popup.swal2-icon-info {
        background-color: #E8F4FD !important;
        color: #155B8A !important;
        border: 2px solid #1E88E5 !important;
      }

      .toast-popup.swal2-icon-warning {
        background-color: #FFF8E1 !important;
        color: #8D6E00 !important;
        border: 2px solid #FBC02D !important;
      }

      .toast-popup.swal2-icon-question {
        background-color: #F3F2F4 !important;
        color: #3C3C3C !important;
        border: 2px solid #9E9E9E !important;
      }
    `;
        document.head.appendChild(style);
        stylesInjected = true;
    }
    return Swal.fire({
        toast: true,               // Enable toast mode
        position: 'bottom-right',  // Position the toast in the bottom-right corner
        icon: alertType,             // Icon type (success, error, info, etc.)
        title: message, // The message to display
        showConfirmButton: false,  // Disable the confirm button
        timer: 3000,               // Time in milliseconds before the toast auto-closes
        timerProgressBar: true,    // Show a progress bar
        showCloseButton: true,     // Optionally show a close button
        customClass: {
            popup: 'toast-popup',
            title: 'toast-title',
        }
    })
}
